import { DeliveryChargeRuleListResponseType } from "@sellar-io/api-v2/types";
import { comparisonFor, formatCurrency } from "@sellar-io/common";
import { Icon } from "@sellar-io/components";
import { ProgressBarGreen } from "../progressBar/ProgressBar";

type FreeDeliveryEligibleProps = {
  freeDeliveryAmount: number;
  orderSubtotal?: number;
  comparator: DeliveryChargeRuleListResponseType[number]["comparator"];
};
export const FreeDeliveryEligibleNotice = ({
  freeDeliveryAmount,
  comparator,
  orderSubtotal,
}: FreeDeliveryEligibleProps): React.ReactElement => {
  const percentage = orderSubtotal
    ? (orderSubtotal / freeDeliveryAmount) * 100
    : 0;

  return (
    <>
      {orderSubtotal ? (
        <>
          {comparisonFor(comparator, orderSubtotal, freeDeliveryAmount) ? (
            <div className={"flex gap-1 text-green-700"}>
              <Icon icon={"CHECK_CIRCLE"} />
              <strong>Your order qualifies for free delivery!</strong>
            </div>
          ) : (
            <div className="flex flex-col gap-2">
              <div className={"text-green-700"}>
                Spend{" "}
                <strong>
                  {formatCurrency(freeDeliveryAmount - orderSubtotal)} more
                </strong>{" "}
                to get free delivery
              </div>
              <ProgressBarGreen percentage={percentage} />
            </div>
          )}
        </>
      ) : (
        <p>
          Free delivery on order subtotals over{" "}
          <strong>{formatCurrency(freeDeliveryAmount)}</strong>
        </p>
      )}
    </>
  );
};
